<template>
  <div>
    <b-navbar id="topbar" toggleable="md" class="align-items-start align-items-md-end">
      <template v-for="group in topbar">
        <b-navbar-nav
          class="align-items-start"
          :class="{ 'align-items-md-end': group === 'right', 'ml-auto': group === 'right' }"
          :test="$i18n.locale"
          v-bind:key="group.id"
        >
          <template v-for="item in items(group)">
            <b-nav-item v-if="item.route=='kontakt'" :to="'/'+$i18n.locale+'/profil'" v-bind:key="group.id+item.id">
              <b>{{userName}}</b>
              {{adresseName}}
            </b-nav-item>
            <b-nav-item
              :to="'/'+$i18n.locale+'/'+item.route"
              v-if="item.route !== '' && item.route !== 'sprache'"
               v-bind:key="item.id"
            >
              <span :class="'glyphicons glyphicons-'+item.icon"></span>
              {{ $t(item.name) }}
            </b-nav-item>
            <language v-if="item.route === 'sprache'"  v-bind:key="item.id"></language>
            <b-nav-item-dropdown right v-if="item.route === ''"  v-bind:key="item.id">
              <template slot="button-content">
                <span :class="'glyphicons glyphicons-'+item.icon"></span>
                {{ $t(item.name) }}
              </template>
              <b-dropdown-item
                v-for="child in item.children"
                :to="'/'+$i18n.locale+'/'+child.route"
                v-bind:key="child.id"
              >
                <span :class="'glyphicons glyphicons-'+child.icon"></span>
                {{ $t(child.name) }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </template>
        </b-navbar-nav>
      </template>
    </b-navbar>
    <b-navbar
      id="burgerbar"
      toggleable="md"
      class="align-items-start align-items-md-end"
      :class="{ test: isTest }"
    >
      <button type="button" v-on:click="SidebarToggle" class="navbar-toggler">
        <span class="navbar-toggler-icon"></span>
      </button>
      <b-navbar-brand :to="'/'+$i18n.locale+'/home'">
        <img :src="logoName" />
      </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <template v-for="group in burgerbar">
          <b-navbar-nav
            class="align-items-start"
            :class="{ 'align-items-md-end': group === 'right', 'ml-auto': group === 'right' }"
            :test="$i18n.locale"
            v-bind:key="group.id"
          >
            <template v-for="item in items(group)">
              <b-nav-item
                :to="'/'+$i18n.locale+'/'+item.route"
                v-if="item.route !== ''"
                v-bind:key="item.id"
              >
                <div
                  class="badge badge-light badge-nav"
                  v-if="(item.route === 'dokumente') && (ungelesen > 0)"
                >{{ ungelesen }}</div>
                <span :class="'glyphicons glyphicons-'+item.icon"></span>
                {{ $t(item.name) }}
              </b-nav-item>
              <b-nav-item-dropdown left v-if="item.route === ''" v-bind:key="item.id">
                <template slot="button-content">
                  <span :class="'glyphicons glyphicons-'+item.icon"></span>
                  {{ $t(item.name) }}
                </template>
                <b-dropdown-item
                  v-for="child in item.children"
                  :to="'/'+$i18n.locale+'/'+child.route"
                  v-bind:key="child.id"
                >
                  <span :class="'glyphicons glyphicons-'+child.icon"></span>
                  {{ $t(child.name) }}
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </template>
          </b-navbar-nav>
        </template>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { bus } from "../main";
export default {
  name: "navigation",
  data() {
    return {
      topbar: ["top", "right"],
      burgerbar: ["left"] // right ist neu in topbar ..
    };
  },
  computed: {
    ungelesen() {
      return this.$store.state.dokumenteStore.ungelesen;
    },
    logoName() {
      return this.$i18n.locale == "de"
        ? "images/logo_dbmilch.png"
        : "images/logo_bdlait.png";
    },
    isTest() {
      return document.URL.substring(0, 12) === "https://test";
    },
    userName() {
      try {
        return this.$store.state.userStore.user.name
          .toString()
          .substring(0, 20);
      } catch (e) {
        return " ";
      }
    },
    adresseName() {
      try {
        return this.$store.state.userStore.adresse.name
          .toString()
          .substring(0, 20 - this.userName.length);
      } catch (e) {
        return " ";
      }
    }
  },
  methods: {
    SidebarToggle() {
      bus.$emit("SidebarToggle");
    },
    items: function(group) {
      return this.$store.state.navigationStore.navigation.filter(function(
        item
      ) {
        return item.group === group;
      });
    },
    routes: function(group) {
      return this.$router.options.routes.filter(function(item) {
        return item.group === group;
      });
    }
  },
  created() {}
};
</script>

<style lang="scss">
@import "../../public/css/tsmVars.scss";

.navbar-nav .nav-link {
  padding-bottom: 0;
}
.glyphicons {
  vertical-align: inherit;
}
.badge {
  border-radius: 1rem !important;
}
.badge-nav {
  position: absolute;
  display: block;
  margin-top: -10px;
  margin-left: 10px;
}
.badge-light {
  background-color: $tsmdunkel !important;
}

#app #topbar.navbar {
  .navbar-nav {
    flex-direction: row;
  }
  .dropdown-menu {
    position: absolute !important;
  }
  .align-items-md-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }

  padding: 0 !important;
  margin: 0 !important;

  .nav-link {
    padding: 0.1em 0.5em;
    font-size: 0.8em;
  }
}

#app #burgerbar.navbar {
  background-color: $tsmnormal;
  margin-bottom: 1rem !important;
  .dropdown-toggle::after {
    display: none;
  }
  li a.nav-link {
    vertical-align: bottom;
    padding-bottom: 0;
  }
}
#app #burgerbar.test {
  background-color: #be9 !important;
}

div#codeLevel {
  display: inline-block;
}
</style>